import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error("[ErrorBoundary] Caught error:", error, errorInfo);
  }

  handleReset = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6 font-sans">
          <div className="max-w-md w-full bg-slate-900/50 backdrop-blur-xl border border-rose-500/30 rounded-2xl p-8 shadow-2xl relative overflow-hidden group">
            <div className="absolute inset-0 bg-gradient-to-br from-rose-500/5 to-transparent opacity-50" />
            
            <div className="relative z-10 text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-rose-500/10 border border-rose-500/20 mb-6 group-hover:scale-110 transition-transform duration-500">
                <AlertTriangle className="w-8 h-8 text-rose-500 animate-pulse" />
              </div>

              <h1 className="text-2xl font-bold text-white mb-2 tracking-tight">
                System Interface Disruption
              </h1>
              
              <p className="text-slate-400 text-sm mb-8 leading-relaxed">
                A critical exception occurred within the UI rendering pipeline. 
                The system has been safely isolated to prevent further instability.
              </p>

              <div className="space-y-3">
                <button
                  onClick={() => window.location.reload()}
                  className="w-full py-3.5 bg-rose-600 hover:bg-rose-500 text-white font-semibold rounded-xl transition-all duration-300 flex items-center justify-center gap-2 group shadow-lg shadow-rose-900/20"
                >
                  <RefreshCw className="w-4 h-4 group-hover:rotate-180 transition-transform duration-700" />
                  Restart Component
                </button>

                <button
                  onClick={this.handleReset}
                  className="w-full py-3.5 bg-slate-800 hover:bg-slate-700 text-slate-200 font-semibold rounded-xl transition-all duration-300 flex items-center justify-center gap-2"
                >
                  <Home className="w-4 h-4" />
                  Return to Command Center
                </button>
              </div>

              <div className="mt-8 pt-6 border-t border-slate-800/50">
                <p className="text-[10px] uppercase tracking-widest text-slate-600 font-bold">
                  Error Code: PIPELINE_UI_CRASH_V1
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
